import { getPrivateApi } from "../lib/axiosConfig";
import { FullSchedule, ScheduleSetting } from "../types/schedulerSettings.types";
import { AppError } from "./classes";

const api = getPrivateApi();
const endpoint = "/scheduler-settings";


export const getStationSchedule = async (stationId: string): Promise<FullSchedule> => {

  try {
    const { data: fullSchedule } = await api.get(`${endpoint}/station/${stationId}`);

    return fullSchedule;

  } catch (error: any) {
    const errMsg = "Erro ao buscar horários!";

    console.error(errMsg, error?.response ?? error);
    
    const message = error?.response?.data?.message ?? errMsg;
    
    throw new AppError(message, error.status);
  };
}

export const updateSchedule = async (schedule: ScheduleSetting): Promise<ScheduleSetting> => {

  const schedulerId = schedule.id;

  try {
    const { data: schedule } = await api.put(`${endpoint}/${schedulerId}`,);

    return schedule;
    
  } catch (error: any) {
    const errMsg = "Erro ao modificar horário!";

    console.error(errMsg, error?.response ?? error);
    
    const message = error?.response?.data?.message ?? errMsg;
    
    throw new AppError(message, error.status);
  };
}